import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {
    
    methods: {

        async sendAssignmentRoom(go_back = false)
        {
            let http_obj = this.$refs.advanced_search.returnedRoomsToParent()

            if(!http_obj.checked_items.length)
            {
                notyf.error('No room-task was selected')

                return;
            }

            http_obj.unchecked_items = http_obj.unchecked_items.map(item => item.room_task_id)

            http_obj['week_form_data'] = this.week_form_data

            this.invoke_loader('post')

            const response = await this.patch(this.rest_api, http_obj)
            
            if(response.status)
            {
                if(go_back)
                {
                    setTimeout(() => {
                        window.location.href = `/assignment-daily-assignments/${this.daily_assignment_id}`
                    }, 250)
                }

                http_obj.checked_items.forEach(checked_item => 
                {
                    const found_index = this.$refs.advanced_search.room_tasks.findIndex(room_task => room_task.room_task_id === checked_item.room_task_id)

                    if(found_index > -1)
                    {
                        this.$refs.advanced_search.room_tasks[found_index].checked = false
                        let associated_assignments = this.$refs.advanced_search.room_tasks[found_index].associated_assignments

                        if(associated_assignments)
                        {
                            this.$refs.advanced_search.room_tasks[found_index].associated_assignments += `,${this.parent.number_assigment}`
                        }
                        else
                        {
                            this.$refs.advanced_search.room_tasks[found_index].associated_assignments = this.parent.number_assigment
                        }
                    }
                })
            } 
            else
            {
                this.error_handling(response)
            }

            this.revoke_loader('post')
        },

        async calculateMinutes()
        {
            let http_obj = this.$refs.advanced_search.returnedRoomsToParent()

            http_obj.unchecked_items = http_obj.unchecked_items.map(item => item.room_task_id)

            http_obj['daily_assignment_id'] = this.parent.id

            const response = await this.post(`${this.lite_rest_api}/calculate_minutes`, http_obj)

            if(response.status)
            {
                this.rooms_assigned_minutes = response.data.current_minutes
                this.proposed_minutes       = response.data.proposed_minutes
                this.total_new_minutes      = response.data.total_new_minutes
            }
            else
            {
                this.error_handling(response)
            }


        },

        fill_data(data)
        {
            this.parent = data.daily_assignment

            if(this.parent)
            {
                this.selfSelectionDaysPerWeek(this.parent.days_per_week)
            }

            this.parent_id = data.parent_id
            

            this.breadcrumb.push(
                {
                    name: `${this.parent.description}`,
                    href: `/assignment-daily-assignments/${this.daily_assignment_id}`,
                    arrow: "<span class='slash'>/</span>",
                },
                {
                    name: `Assignment - ${this.parent.description}`,
                    href: '#',
                    arrow: "",
                }
            )
        },

        selfSelectionDaysPerWeek(number_days)
        {
            if(number_days === 7)
            {
                this.week_form_data.sunday = true
                this.week_form_data.monday = true
                this.week_form_data.tuesday = true
                this.week_form_data.wednesday = true
                this.week_form_data.thursday = true
                this.week_form_data.friday = true
                this.week_form_data.saturday = true
            }
            else if(number_days === 5)
            {
                this.week_form_data.monday = true
                this.week_form_data.tuesday = true
                this.week_form_data.wednesday = true
                this.week_form_data.thursday = true
                this.week_form_data.friday = true
            }
        },

        getInitialData(data)
        {
            this.fill_data(data)
            this.calculateMinutes()
        },

        reloaded()
        {
            window.location.reload()
        },

    },

}

export default Methods